import React from 'react'
import PropTypes from 'prop-types'
import { useMakeSelector } from 'hooks/redux'
import { opMap, OPERATORS } from 'components/utils'
import strings from 'utils/strings'
import { signalTranslationRangeSymbolLabel } from 'i18n/displayConstants/signals'
import { translationValue } from 'utils/translations'
import { makeGetScalingQuerySelector } from 'selectors/feature/scalingQueries'

import ReadOnlyParameterValue from 'components/feature/NavigatorPanes/editors/base/ReadOnlyParameterValue'
import { CAN_INPUT } from 'utils/constants'

const labelText = ({
  selectedInputDescription,
  valueMin,
  valueMax,
  units,
  translations,
  translationType,
  queryType,
  numberOfBits,
  canId,
}) => {
  if (queryType === CAN_INPUT && numberOfBits && canId) {
    return strings.can_input_description(numberOfBits, canId)
  }

  if (!selectedInputDescription) {
    return strings.undefined
  }

  const valueWithUnits = (val) =>
    `${translationValue(val, translationType, translations)}${
      signalTranslationRangeSymbolLabel(units) || ''
    }`

  const scalingQueryText = `${valueWithUnits(valueMin)} ${
    opMap[OPERATORS.LESS_THAN_OR_EQUAL]
  } ${selectedInputDescription} ${
    opMap[OPERATORS.LESS_THAN_OR_EQUAL]
  } ${valueWithUnits(valueMax)}`

  return scalingQueryText
}

const ReadOnlyScaling = ({ uri }) => {
  const scalingQuery = useMakeSelector(makeGetScalingQuerySelector, { uri })
  const value = labelText({
    ...scalingQuery,
  })

  return <ReadOnlyParameterValue value={value} label={strings.scaling_input} />
}

export default ReadOnlyScaling

ReadOnlyScaling.propTypes = {
  uri: PropTypes.string,
}
